export default function($store) {
  return {
    name: 'customsMonetateQ',
    type: {
      setPageType: 'setPageType',
      addCartRows: 'addCartRows',
      addProductDetails: 'addProductDetails'
    },
    /**
     * @function logEvent
     * @description Adds an event to MonetateQ dataLayer.
     *
     * @param {object} payload
     * @param {string} event
     * @returns {void}
     */
    logEvent: function (event, payload) {
      if (!window.monetateQ) console.error('MonetateQ does not exist');
      else if (!this.type[event]) console.error('Event doesnt exist', event, payload);
      else if ($store.getters['utils/vsfActive']) {
        const data = [event, payload];
        window.monetateQ.push(data);
        window.monetateQ.push(['trackData']);
      }
    }
  };
};
